import api from "../lib/axios";

// site auth
export const getSiteDataUsingIdForQR = async (id, eventId) => {
  const res = await api.get(`/leads/scan/${eventId}/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// site add leads
export const addSiteLead = async (eventId, data) => {
  const res = await api.post(
    `/leads/${eventId}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return res;
};

// site get leads
export const getSiteLeads = async (eventId, exhibitor_id, params = {}) => {
  const res = await api.get(`/leads/${eventId}/${exhibitor_id}`, {
    params,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// site get tickets
export const getSiteTickets = async (eventId) => {
  const res = await api.get(`/site/${eventId}/ticket`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// get space overview
export const getExhibitorSpaceOverview = async (eventId) => {
  const res = await api.get(`/site/${eventId}/space/overview`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// update site lead
export const updateSiteLead = async (id, data) => {
  const res = await api.put(`/leads/${id}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// delete site lead
export const deleteSiteLead = async (id) => {
  const res = await api.delete(`/leads/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

// get lead types
export const getLeadConfigTypes = async () => {
  const res = await api.get("/leads/config/types", {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

export const getSiteBoothMembers = async (params) => {
  const res = await api.get(`/exhibitor/booth-member/site/list`, {
    params,
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const createSiteBoothMember = async (memberData) => {
  const res = await api.post(`/exhibitor/booth-member/site/create`, memberData, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const updateSiteBoothMember = async (memberId, updateData) => {
  const res = await api.put(`/exhibitor/booth-member/site/update/${memberId}`, updateData, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const deleteSiteBoothMember = async (memberId) => {
  const res = await api.delete(`/exhibitor/booth-member/site/delete/${memberId}`, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const reinviteSiteBoothMember = async (memberId) => {
  const res = await api.post(`/exhibitor/booth-member/site/reinvite/${memberId}`, {}, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const updateBoothMemberProfile = async (memberId, profileData) => {
  const isFormData = profileData instanceof FormData;
  const config = isFormData ? { headers: { "Content-Type": undefined } } : undefined;
  const res = await api.put(`/exhibitor/booth-member/site/update-member/${memberId}`, profileData, config);
  return res;
};

export const updateSiteExhibitor = async (exhibitorId, exhibitorData) => {
  const isFormData = exhibitorData instanceof FormData;
  const config = isFormData ? { headers: { "Content-Type": undefined } } : undefined;
  const res = await api.put(`/allexhibitor/site/update/${exhibitorId}`, exhibitorData, config);
  return res;
};

export const getSpaceRolePermissions = async (eventId, roleId) => {
  const res = await api.get(`/site/${eventId}/space/role-permissions`, {
    params: { roleId },
  });
  return res;
};

export const getExhibitorMedia = async (exhibitorId) => {
  const res = await api.get(`/exhibitor/media/${exhibitorId}`);
  return res;
};

export const createExhibitorMedia = async (data, options = {}) => {
  const res = await api.post(`/exhibitor/media`, data, options);
  return res;
};

export const updateExhibitorMedia = async (id, data, options = {}) => {
  const res = await api.put(`/exhibitor/media/${id}`, data, options);
  return res;
};

export const deleteExhibitorMedia = async (id) => {
  const res = await api.delete(`/exhibitor/media/${id}`);
  return res;
};

export const getPromotionalBanners = async (exhibitorId) => {
  const res = await api.get(`/exhibitor/promotional-banners/${exhibitorId}`);
  return res;
};

export const createPromotionalBanner = async (formData, options = {}) => {
  const res = await api.post(`/exhibitor/promotional-banners`, formData, options);
  return res;
};

export const updatePromotionalBanner = async (id, formData, options = {}) => {
  const res = await api.put(`/exhibitor/promotional-banners/${id}`, formData, options);
  return res;
};

export const deletePromotionalBanner = async (id) => {
  const res = await api.delete(`/exhibitor/promotional-banners/${id}`);
  return res;
};
